import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=7827d1ec&scoped=true&"
import script from "./NotificationDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827d1ec",
  null
  
)

export default component.exports